<template>
  <div class="admin-body">
    <div id="nav" class="admin-nav navbar-collapse">
      <div class="admin-nav-fixbox">
        <PrimaryNavigation />
        <SecondaryNavigation />
      </div>
    </div>
    <PageWithNavbar />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

import PageWithNavbar from './PageWithNavbar.vue';
import PrimaryNavigation from '../navigation/PrimaryNavigation.vue';
import SecondaryNavigation from '../navigation/SecondaryNavigation.vue';

@Component({
  components: {
    PageWithNavbar,
    PrimaryNavigation,
    SecondaryNavigation
  }
})
class HouseholdAdmin extends Vue {
  mounted() {
    document.querySelector(".navbar-toggler").addEventListener("click", function(e) { // eslint-disable-line no-unused-vars
      document.querySelector("#nav").classList.toggle("admin-nav-toggle");
      document.querySelector(".admin-nav-trigger").classList.toggle("active");
    });
  }
}
export default HouseholdAdmin;
</script>

<style scoped>
.admin-body {
  display: flex;
  flex-shrink: 0;
  flex-basis: auto;
  flex-direction: row;
  flex-grow: 1;
}

.admin-nav {
  align-items: unset;
}

</style>
